import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/newWallet',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewWallet-index" */ '~/pages/NewWallet/pages/index'
        )
    ),
  },
  {
    path: '/riap',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-riap-r-index" */ '~/pages/NewWallet/pages/r_index'
        )
    ),
  },
  {
    path: '/hiyawallet',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewWallet-redirect" */ '~/pages/NewWallet/pages/redirect'
        )
    ),
  },
  {
    path: '/newWallet/search',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewWallet-search" */ '~/pages/NewWallet/pages/search'
        )
    ),
  },
] as RouteConfig[]
